"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_PARSER_OPTIONS = void 0;
const types_1 = require("@stoplight/types");
exports.DEFAULT_PARSER_OPTIONS = Object.freeze({
    incompatibleValues: types_1.DiagnosticSeverity.Error,
    duplicateKeys: types_1.DiagnosticSeverity.Error,
});
//# sourceMappingURL=consts.js.map